/* ==========================================================
   PEARL DELIVERY ENGINE
   Global reusable delivery logic
   ========================================================== */

window.PearlDelivery = (function() {

  const SYD_TZ = "Australia/Sydney";
  const DELIVERY_CUTOFF = 1500; // 3:00pm

  const HOLIDAYS = [
    "2025-12-25","2025-12-26",
    "2026-01-01","2026-01-26","2026-04-03","2026-04-04",
    "2026-04-05","2026-04-06","2026-04-25",
    "2026-06-08","2026-10-05",
    "2026-12-25","2026-12-28"
  ];

  /* ==========================================================
     DELIVERY DATA (embedded — no fetch required)
     ========================================================== */

  const POSTCODES = [
    "2000","2001","2002","2004","2006","2007","2008","2009","2010","2011",
    "2012","2015","2016","2017","2018","2019","2020","2021","2022","2023",
    "2024","2025","2026","2027","2028","2029","2030","2031","2032","2033",
    "2034","2035","2036","2037","2038","2039","2040","2041","2042","2043",
    "2044","2045","2046","2047","2048","2049","2050","2052","2055","2057",
    "2058","2059","2060","2061","2062","2063","2064","2065","2066","2067",
    "2068","2069","2070","2071","2072","2073","2074","2075","2076","2077",
    "2079","2080","2081","2082","2084","2085","2086","2087","2088","2089",
    "2090","2091","2092","2093","2094","2095","2096","2097","2099","2100",
    "2101","2102","2103","2104","2105","2106","2107","2108","2109","2110",
    "2111","2112","2113","2114","2115","2116","2117","2118","2119","2120",
    "2121","2122","2123","2124","2125","2126","2127","2128","2129","2130",
    "2131","2132","2133","2134","2135","2136","2137","2138","2139","2140",
    "2141","2142","2143","2144","2145","2146","2147","2148","2150","2151",
    "2152","2153","2154","2155","2156","2157","2158","2159","2160","2161",
    "2162","2163","2164","2165","2166","2167","2168","2170","2171","2173",
    "2174","2175","2176","2177","2178","2179","2190","2191","2192","2193",
    "2194","2195","2196","2197","2198","2199","2200","2203","2204","2205",
    "2206","2207","2208","2209","2210","2211","2212","2213","2214","2216",
    "2217","2218","2219","2220","2221","2222","2223","2224","2225","2226",
    "2227","2228","2229","2230","2231","2232","2233","2234","2309","2500",
    "2502","2505","2506","2508","2515","2516","2517","2518","2519","2520",
    "2521","2522","2525","2526","2528","2555","2556","2557","2558","2559",
    "2560","2563","2564","2565","2566","2567","2568","2569","2570",
    "2572","2573","2575","2745","2747","2748","2749","2750","2751",
    "2752","2753","2755","2756","2759","2760","2761","2762","2763","2765",
    "2766","2767","2768","2769","2770","2773","2774","2776","2777","2778"
  ];

  const SUBURB_MAP = {
    "abbotsbury":"2176","abbotsford":"2046","acacia gardens":"2763","agnes banks":"2753",
    "airds":"2560","alexandria":"2015","alexandria mc":"2004","alfords point":"2234",
    "allambie":"2100","allambie heights":"2100","allawah":"2218","alpine":"2575",
    "ambarvale":"2560","annandale":"2038","annangrove":"2156","appin":"2560",
    "arcadia":"2159","arncliffe":"2205","arndell park":"2148","artarmon":"2064",
    "ashbury":"2193","ashcroft":"2168","ashfield":"2131","asquith":"2077",
    "auburn":"2144","audley":"2232","austinmer":"2515","austral":"2179",
    "avalon beach":"2107","aylmerton":"2575","badgerys creek":"2555",
    "balaclava":"2575","balgowlah":"2093","balgowlah heights":"2093","balgownie":"2519",
    "balmain":"2041","balmain east":"2041","balmoral":"2571","balmoral village":"2571",
    "bangor":"2234","banksia":"2216","banksmeadow":"2019","bankstown":"2200",
    "bankstown aerodrome":"2200","bankstown north":"2200","bankstown square":"2200",
    "barangaroo":"2000","barden ridge":"2234","bardia":"2565","bardwell park":"2207",
    "bardwell valley":"2207","barrack heights":"2528","barrack point":"2528",
    "bass hill":"2197","baulkham hills":"2153","bayview":"2104","beacon hill":"2100",
    "beaconsfield":"2015","beaumont hills":"2155","beecroft":"2119","belfield":"2191",
    "belimbla park":"2570","bella vista":"2153","bellambi":"2518","bellevue hill":"2023",
    "belmore":"2192","belrose":"2085","belrose west":"2085","ben buckler":"2026",
    "berala":"2141","berkeley":"2506","berkshire park":"2765","berowra":"2081",
    "berowra creek":"2082","berowra heights":"2082","berowra waters":"2082","berrilee":"2159",
    "beverley park":"2217","beverly hills":"2209","bexley":"2207","bexley north":"2207",
    "bexley south":"2207","bickley vale":"2570","bidwill":"2770","bilgola":"2107",
    "bilgola beach":"2107","bilgola plateau":"2107","birchgrove":"2041","birrong":"2143",
    "blackett":"2770","blacktown":"2148","blacktown westpoint":"2148","blair athol":"2560",
    "blairmount":"2559","blakehurst":"2221","blaxcell":"2142","blaxland":"2774",
    "blaxland east":"2774","blenheim road":"2113","bligh park":"2756","bondi":"2026",
    "bondi beach":"2026","bondi junction":"2022","bonnet bay":"2226","bonnyrigg":"2177",
    "bonnyrigg heights":"2177","boronia park":"2111","bossley park":"2176","botany":"2019",
    "bow bowing":"2566","bowen mountain":"2753","box hill":"2765","bradbury":"2560",
    "braemar":"2575","breakfast point":"2137","brighton-le-sands":"2216","bringelly":"2556",
    "broadway":"2007","bronte":"2024","brookvale":"2100","brownlow hill":"2570",
    "bulli":"2516","bullio":"2575","bungarribee":"2767","burraneer":"2230",
    "burwood":"2134","burwood heights":"2136","burwood north":"2134","busby":"2168",
    "buxton":"2571","cabarita":"2137","cabramatta":"2166","cabramatta west":"2166",
    "caddens":"2747","cambridge gardens":"2747","cambridge park":"2747","camden":"2570",
    "camden park":"2570","camden south":"2570","camellia":"2142","cammeray":"2062",
    "campbelltown":"2560","campbelltown north":"2560","camperdown":"2050","campsie":"2194",
    "canada bay":"2046","canley heights":"2166","canley vale":"2166","canoelands":"2157",
    "canterbury":"2193","careel bay":"2107","caringbah":"2229","caringbah south":"2229",
    "carlingford":"2118","carlingford court":"2118","carlingford north":"2118","carlton":"2218",
    "carnes hill":"2171","carramar":"2163","carss park":"2221","cartwright":"2168",
    "castle cove":"2069","castle hill":"2154","castlecrag":"2068","castlereagh":"2749",
    "casula":"2170","casula mall":"2170","cataract":"2560","catherine field":"2557",
    "cattai":"2756","cawdor":"2570","cecil hills":"2171","cecil park":"2178",
    "centennial park":"2021","central colo":"2756","chatswood":"2067","chatswood west":"2067",
    "cheltenham":"2119","cherrybrook":"2126","chester hill":"2162","chifley":"2036",
    "chippendale":"2008","chipping norton":"2170","chiswick":"2046","chullora":"2190",
    "church point":"2105","claremont meadows":"2747","clarendon":"2756","clareville":"2107",
    "claymore":"2559","clemton park":"2206","clifton":"2515","clontarf":"2093",
    "clovelly":"2031","clovelly west":"2031","clyde":"2142","coalcliff":"2508",
    "coasters retreat":"2108","cobbitty":"2570","colebee":"2761","coledale":"2515",
    "collaroy":"2097","collaroy beach":"2097","collaroy plateau":"2097","colo":"2756",
    "colo heights":"2756","colo vale":"2575","colyton":"2760","como":"2226",
    "concord":"2137","concord repatriation hospital":"2139","concord west":"2138",
    "condell park":"2200","coniston":"2500","connells point":"2221","constitution hill":"2145",
    "coogee":"2034","cordeaux":"2526","cordeaux heights":"2526","cornwallis":"2756",
    "corrimal":"2518","corrimal east":"2518","cottage point":"2084","couridjah":"2571",
    "cowan":"2081","cranebrook":"2749","cremorne":"2090","cremorne junction":"2090",
    "cremorne point":"2090","cringila":"2502","cromer":"2099","cronulla":"2230",
    "crows nest":"2065","croydon":"2132","croydon park":"2133","cumberland reach":"2756",
    "curl curl":"2096","currans hill":"2567","currawong beach":"2108","daceyville":"2032",
    "dangar":"2309","darkes forest":"2508","darling point":"2027","darlinghurst":"2010",
    "darlington":"2008","davidson":"2085","dawes point":"2000","dean park":"2761",
    "dee why":"2099","denham court":"2565","denistone":"2114","denistone east":"2112",
    "denistone west":"2114","dharruk":"2770","dolans bay":"2229","dolls point":"2219",
    "doonside":"2767","double bay":"2028","douglas park":"2569","dover heights":"2030",
    "drummoyne":"2047","duffys forest":"2084","dulwich hill":"2203","dundas":"2117",
    "dundas valley":"2117","dural":"2158","eagle vale":"2558","earlwood":"2206",
    "east corrimal":"2518","east hills":"2213","east killara":"2071","east lindfield":"2070",
    "east ryde":"2113","eastern creek":"2766","eastern suburbs mc":"2004","eastgardens":"2036",
    "eastlakes":"2018","eastwood":"2122","ebenezer":"2756","edensor park":"2176",
    "edgecliff":"2027","edmondson park":"2174","elanora heights":"2101","elderslie":"2570",
    "elizabeth bay":"2011","elizabeth hills":"2171","ellis lane":"2570","elvina bay":"2105",
    "emerton":"2770","emu heights":"2750","emu plains":"2750","enfield":"2136",
    "enfield south":"2133","engadine":"2233","englorie park":"2560","enmore":"2042",
    "epping":"2121","ermington":"2115","erskine park":"2759","erskineville":"2043",
    "eschol park":"2558","eveleigh":"2015","fairfield":"2165","fairfield east":"2165",
    "fairfield heights":"2165","fairfield west":"2165","fairlight":"2094","fairy meadow":"2519",
    "farmborough heights":"2526","faulconbridge":"2776","fernhill":"2519","fiddletown":"2159",
    "figtree":"2525","five dock":"2046","forest glen":"2157","forest lodge":"2037",
    "forestville":"2087","freemans reach":"2756","frenchs forest":"2086","frenchs forest east":"2086",
    "freshwater":"2096","galston":"2159","georges hall":"2198","gilead":"2560",
    "girraween":"2145","gladesville":"2111","glebe":"2037","gledswood hills":"2557",
    "glen alpine":"2560","glenbrook":"2773","glendenning":"2761","glenfield":"2167",
    "glenhaven":"2156","glenmore":"2570","glenmore park":"2745","glenorie":"2157",
    "glenquarie":"2564","glenwood":"2768","glossodia":"2756","goodmans ford":"2575",
    "gordon":"2072","gore hill":"2065","granville":"2142","grasmere":"2570",
    "grays point":"2232","great mackerel beach":"2108","green valley":"2168","greenacre":"2190",
    "greendale":"2745","greenfield park":"2176","greenhills beach":"2230","greenwich":"2065",
    "gregory hills":"2557","greystanes":"2145","grose vale":"2753","grose wold":"2753",
    "guildford":"2161","guildford west":"2161","gwynneville":"2500","gymea":"2227",
    "gymea bay":"2227","haberfield":"2045","hammondville":"2170","harbord":"2096",
    "harrington park":"2567","harris park":"2150","hassall grove":"2761","hawkesbury heights":"2777",
    "haymarket":"2000","heathcote":"2233","hebersham":"2770","heckenberg":"2168",
    "helensburgh":"2508","henley":"2111","high range":"2575","hill top":"2575",
    "hillsdale":"2036","hinchinbrook":"2168","hmas penguin":"2091","hmas platypus":"2060",
    "hmas rushcutters":"2027","hmas waterhen":"2060","hmas watson":"2030","hobartville":"2753",
    "holroyd":"2142","holsworthy":"2173","homebush":"2140","homebush bay":"2127",
    "homebush south":"2140","homebush west":"2140","horningsea park":"2171","hornsby":"2077",
    "hornsby heights":"2077","horsley park":"2175","hoxton park":"2171","hunters hill":"2110",
    "huntingwood":"2148","huntleys cove":"2111","huntleys point":"2111","hurlstone park":"2193",
    "hurstville":"2220","hurstville grove":"2220","hurstville westfield":"2220","illawong":"2234",
    "ingleburn":"2565","ingleside":"2101","jamisontown":"2750","jannali":"2226",
    "joadja":"2575","jordan springs":"2747","kangaroo point":"2224","kareela":"2232",
    "kearns":"2558","keiraville":"2500","kellyville":"2155","kellyville ridge":"2155",
    "kembla grange":"2526","kembla heights":"2526","kemblawarra":"2505","kemps creek":"2178",
    "kensington":"2033","kenthurst":"2156","kentlyn":"2560","killara":"2071",
    "killarney heights":"2087","kings cross":"2011","kings langley":"2147","kings park":"2148",
    "kingsdene":"2118","kingsford":"2032","kingsgrove":"2208","kingsway west":"2208",
    "kingswood":"2747","kirkham":"2570","kirrawee":"2232","kirribilli":"2061",
    "kogarah":"2217","kogarah bay":"2217","kurnell":"2231","kurraba point":"2089",
    "kyeemagh":"2216","kyle bay":"2221","la perouse":"2036","lake heights":"2502",
    "lake illawarra":"2528","lakemba":"2195","lakesland":"2572","lalor park":"2147",
    "lane cove":"2066","lane cove north":"2066","lane cove west":"2066","lansdowne":"2163",
    "lansvale":"2166","lapstone":"2773","lavender bay":"2060","leichhardt":"2040",
    "len waters estate":"2171","leonay":"2750","leppington":"2179","lethbridge park":"2770",
    "leumeah":"2560","lewisham":"2049","liberty grove":"2138","lidcombe":"2141",
    "lidcombe north":"2141","lilli pilli":"2229","lilyfield":"2040","linden":"2778",
    "lindfield":"2070","lindfield west":"2070","linley point":"2066","little bay":"2036",
    "liverpool":"2170","liverpool south":"2170","liverpool westfield":"2170","llandilo":"2747",
    "loftus":"2232","londonderry":"2753","long point":"2564","longueville":"2066",
    "lovett bay":"2105","lower portland":"2756","lucas heights":"2234","luddenham":"2745",
    "lugarno":"2210","lurnea":"2170","macarthur square":"2560","macquarie centre":"2113",
    "macquarie fields":"2564","macquarie links":"2565","macquarie park":"2113",
    "macquarie university":"2109","maddens plains":"2508","malabar":"2036","maldon":"2571",
    "manahan":"2200","mandemar":"2575","mangerton":"2500","manly":"2095","manly east":"2095",
    "manly vale":"2093","maraylya":"2765","marayong":"2148","maroota":"2756","maroubra":"2035",
    "maroubra south":"2035","marrickville":"2204","marrickville metro":"2204",
    "marrickville south":"2204","marsden park":"2765","marsfield":"2122","mascot":"2020",
    "matraville":"2036","mays hill":"2145","mccarrs creek":"2105","mcgraths hill":"2756",
    "mcmahons point":"2060","meadowbank":"2114","mellong":"2756","melrose park":"2114",
    "menai":"2234","menai central":"2234","menangle":"2568","menangle park":"2563",
    "merrylands":"2160","merrylands west":"2160","middle cove":"2068","middle dural":"2158",
    "middleton grange":"2171","miller":"2168","millers point":"2000","milperra":"2214",
    "milsons point":"2061","minchinbury":"2770","miranda":"2228","mona vale":"2103",
    "monterey":"2217","moorebank":"2170","mortdale":"2223","mortlake":"2137","mosman":"2088",
    "mount annan":"2567","mount colah":"2079","mount druitt":"2770","mount hunter":"2570",
    "mount kuring-gai":"2080","mount lewis":"2190","mount pritchard":"2170","mount vernon":"2178",
    "mulgoa":"2745","narellan":"2567","narellan vale":"2567","naremburn":"2065",
    "narrabeen":"2101","narraweena":"2099","neutral bay":"2089","newington":"2127",
    "newport":"2106","newtown":"2042","normanhurst":"2076","north balgowlah":"2093",
    "north bondi":"2026","north curl curl":"2099","north epping":"2121","north manly":"2100",
    "north narrabeen":"2101","north parramatta":"2151","north richmond":"2754",
    "north rocks":"2151","north ryde":"2113","north st marys":"2760","north steyne":"2095",
    "north strathfield":"2137","north sydney":"2060","north turramurra":"2074",
    "north willoughby":"2068","northbridge":"2063","northmead":"2152","northwood":"2066",
    "norwest":"2153","oakhurst":"2761","oakville":"2765","oatlands":"2117","oatley":"2223",
    "old guildford":"2161","old toongabbie":"2146","oran park":"2570","orchard hills":"2748",
    "oxford falls":"2100","oyster bay":"2225","paddington":"2021","padstow":"2211",
    "padstow heights":"2211","pagewood":"2035","palm beach":"2108","panania":"2213",
    "parklea":"2768","parramatta":"2150","peakhurst":"2210","peakhurst heights":"2210",
    "pemulwuy":"2145","pendle hill":"2145","pennant hills":"2120","penrith":"2750",
    "petersham":"2049","phillip bay":"2036","picnic point":"2213","picton":"2571",
    "pitt town":"2756","pleasure point":"2172","plumpton":"2761","point piper":"2027",
    "port botany":"2036","port hacking":"2229","potts point":"2011","prairiewood":"2176",
    "prestons":"2170","prospect":"2148","punchbowl":"2196","putney":"2112","pymble":"2073",
    "pyrmont":"2009","quakers hill":"2763","queens park":"2022","queenscliff":"2096",
    "raby":"2566","randwick":"2031","redfern":"2016","regents park":"2143","revesby":"2212",
    "revesby heights":"2212","rhodes":"2138","richmond":"2753","riverstone":"2765",
    "riverwood":"2210","rockdale":"2216","rodd point":"2046","rookwood":"2141",
    "rosehill":"2142","rosemeadow":"2560","roseville":"2069","roseville chase":"2069",
    "rossmore":"2557","rooty hill":"2766","rouse hill":"2155","rozelle":"2039","ruse":"2560",
    "russell lea":"2046","rydalmere":"2116","ryde":"2112","sadleir":"2168","sans souci":"2219",
    "sarsfield":"2570","schofields":"2762","seaforth":"2092","sefton":"2162",
    "seven hills":"2147","shalvey":"2770","silverwater":"2128","smeaton grange":"2567",
    "smithfield":"2164","south coogee":"2034","south granville":"2142","south hurstville":"2221",
    "south penrith":"2750","south turramurra":"2074","south wentworthville":"2145",
    "south windsor":"2756","spring farm":"2570","st clair":"2759","st helens park":"2560",
    "st ives":"2075","st ives chase":"2075","st johns park":"2176","st leonards":"2065",
    "st marys":"2760","st peters":"2044","stanmore":"2048","stanhope gardens":"2768",
    "strathfield":"2135","strathfield south":"2136","summer hill":"2130","surry hills":"2010",
    "sutherland":"2232","sydenham":"2044","sydney":"2000","sydney olympic park":"2127",
    "sylvania":"2224","sylvania waters":"2224","tahmoor":"2573","tamarama":"2026",
    "taren point":"2229","telopea":"2117","tempe":"2044","terrey hills":"2084",
    "the entrance":"2261","the oaks":"2570","the rocks":"2000","thirlmere":"2572",
    "thirroul":"2515","thornleigh":"2120","toongabbie":"2146","tregear":"2770",
    "turramurra":"2074","ultimo":"2007","unanderra":"2526","university of sydney":"2006",
    "unsw sydney":"2052","uts":"2007","varroville":"2566","vaucluse":"2030",
    "villawood":"2163","vineyard":"2765","voyager point":"2172","wahroonga":"2076",
    "waitara":"2077","wakeley":"2176","wallacia":"2745","warrawee":"2074",
    "warwick farm":"2170","waterfall":"2233","waterloo":"2017","watsons bay":"2030",
    "waverley":"2024","wedderburn":"2560","wentworth point":"2127","wentworthville":"2145",
    "west hoxton":"2171","west pennant hills":"2125","west pymble":"2073","west ryde":"2114",
    "westfield":"2204","westleigh":"2120","westmead":"2145","wetherill park":"2164",
    "whalan":"2770","wheeler heights":"2097","willoughby":"2068","willoughby east":"2068",
    "windsor":"2756","winston hills":"2153","wiley park":"2195","wollongong":"2500",
    "wollstonecraft":"2065","woodbine":"2560","woodcroft":"2767","woodpark":"2164",
    "woollahra":"2025","woolloomooloo":"2011","woolooware":"2230","woolwich":"2110",
    "woronora":"2232","woronora heights":"2233","yagoona":"2199","yennora":"2161",
    "yowie bay":"2228","zetland":"2017"
  };

  /* ==========================================================
     DATE / TIME HELPERS
     ========================================================== */

  function sydParts(opts){
    var fmt = new Intl.DateTimeFormat("en-CA", Object.assign({ timeZone: SYD_TZ }, opts||{}));
    var parts = fmt.formatToParts(new Date()), out={};
    for (var i=0;i<parts.length;i++) out[parts[i].type] = parts[i].value;
    return out;
  }

  function sydneyHM(){ 
    var p=sydParts({hour:"2-digit",minute:"2-digit",hour12:false}); 
    return parseInt(p.hour+p.minute,10); 
  }

  function sydneyTodayYMD(){ 
    var p=sydParts({year:"numeric","month":"2-digit","day":"2-digit"}); 
    return { y:+p.year, m0:+p.month-1, d:+p.day }; 
  }

  function isoFromYMD(y, mZero, d) {
    return (
      y + "-" +
      String(mZero + 1).padStart(2, "0") + "-" +
      String(d).padStart(2, "0")
    );
  }

  function daysInMonth(y,mZero){ 
    return new Date(y, mZero+1, 0).getDate(); 
  }

  function addOneDay(y,m0,d){
    d += 1;
    if (d > daysInMonth(y,m0)) {
      d = 1; m0 += 1;
      if (m0 > 11) { m0 = 0; y += 1; }
    }
    return { y:y, m0:m0, d:d };
  }

  function weekdayMon0For(y, m0, d) {
    var sun0 = new Date(Date.UTC(y, m0, d)).getUTCDay();
    return (sun0 + 6) % 7;
  }

  function isSundayISO(iso){
    var y = +iso.slice(0,4), m0 = +iso.slice(5,7)-1, d = +iso.slice(8,10);
    return weekdayMon0For(y,m0,d) === 6;
  }

  function isHoliday(iso){ 
    return HOLIDAYS.includes(iso); 
  }

  /* ==========================================================
     CORE DELIVERY LOGIC
     ========================================================== */

  function getNextDeliveryISO(){
    var hm = sydneyHM();
    var t = sydneyTodayYMD();

    var y = t.y, m0 = t.m0, d = t.d + (hm >= DELIVERY_CUTOFF ? 2 : 1);

    while (d > daysInMonth(y,m0)) {
      d -= daysInMonth(y,m0);
      m0++;
      if (m0>11){m0=0;y++;}
    }

    while (true){
      var iso = isoFromYMD(y,m0,d);
      if (!isHoliday(iso) && !isSundayISO(iso)) {
        return iso;
      }
      var nxt = addOneDay(y,m0,d);
      y=nxt.y; m0=nxt.m0; d=nxt.d;
    }
  }

  function formatLongAU(iso){
    var y=+iso.slice(0,4), m0=+iso.slice(5,7)-1, d=+iso.slice(8,10);
    return new Date(y,m0,d).toLocaleDateString("en-AU", { 
      weekday:"long", day:"numeric", month:"long", year:"numeric"
    });
  }

  function getNextDeliveryFormatted(){
    return formatLongAU(getNextDeliveryISO());
  }

  function getCutoffFormatted(){
    return "3pm";
  }

  /* ==========================================================
     POSTCODE CHECKER
     ========================================================== */

  function checkPostcode() {
    var input = document.getElementById('postcode-input');
    var msg   = document.getElementById('postcode-message');

    if (!input || !msg) return;

    var raw = input.value.trim().toLowerCase();

    if (!raw) {
      msg.style.color = '#888888';
      msg.textContent = 'Please enter a suburb or postcode.';
      return;
    }

    var matched = false;

    if (/^\d{4}$/.test(raw)) {
      // Numeric — check postcode list directly
      matched = POSTCODES.indexOf(raw) !== -1;
    } else {
      // Suburb name — look up in map
      matched = SUBURB_MAP.hasOwnProperty(raw);
    }

    if (matched) {
      msg.style.color = '#00ccff';
      msg.textContent = '\u2713 Great news! We deliver to your area. Next delivery: ' + getNextDeliveryFormatted() + '.';
    } else {
      msg.style.color = '#ff4444';
      msg.textContent = '\u2717 Sorry, we don\'t currently deliver to that area.';
    }
  }

  /* ==========================================================
     PUBLIC API
     ========================================================== */

  return {
    getNextDeliveryISO:       getNextDeliveryISO,
    getNextDeliveryFormatted: getNextDeliveryFormatted,
    getCutoffFormatted:       getCutoffFormatted,
    checkPostcode:            checkPostcode
  };

})();
